module.exports = __webpack_public_path__ + "static/img/image021.8f6e743.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image021.png
// module id = BeAj
// module chunks = 1